import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import SellerPortalShell from '@pages/SellerPortal'
import SellerRegistration from '@components/seller/SellerRegistration'
import { RoleGuard } from '@portals/shared/guards/RoleGuard'
import { PortalLoginPage } from '@portals/shared/components/PortalLoginPage'
import { ToastProvider } from '@/components/feedback/ToastProvider'
import { DialogProvider } from '@/components/ui'

// DEBUG: Verify V2 Load


export function SellerPortal() {
  const renderSellerLogin = () => (
    <PortalLoginPage
      portal="seller"
      title="Seller Workspace Sign In"
      description={[
        'Manage catalog, pricing, and order fulfillment from your dedicated seller workspace.',
        'Use the credentials created during seller onboarding.'
      ]}
      scope="seller"
      requestedScopes={['inventory:self', 'orders:self', 'documents:self']}
      redirectPath="/"
      allowedRoles={['SELLER', 'SUPER_ADMIN']}
      supportRegister
      registerPath="/register"
    />
  )

  return (
    <Router>
      <ToastProvider>
        <DialogProvider>
        <Routes>
          <Route
            path="/login"
            element={renderSellerLogin()}
          />
          <Route path="/register" element={<SellerRegistration />} />
          <Route
            path="/*"
            element={
              <RoleGuard
                portal="seller"
                allowedRoles={['SELLER', 'SUPER_ADMIN']}
                fallback={renderSellerLogin()}
              // requiredScopes={['inventory:self', 'orders:self', 'documents:self']} // Bypass Scope Check
              >
                <SellerPortalShell />
              </RoleGuard>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </DialogProvider>
      </ToastProvider>
    </Router>
  )
}
